import { useRef, useState } from "react"
import { Box, Chip, Typography } from "@mui/material"
import { ScheduleSummary } from "routes/schedule/plugins/ai-summary/ai-summary.runtime"
import { CloseIcon } from "~/theme/overrides/CustomIcons.js"
import { useTheme } from "@mui/styles"

export function MultiSelectionChipPreviewItem({ item, onRemove }) {
    const [focused, setFocused] = useState(false)
    const chipRef = useRef(null)
    const theme = useTheme()

    return (
        <Chip
            data-cy="multi-selection-chip-item"
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            component="button"
            ref={chipRef}
            label={
                <Box sx={{ gap: 0.5, alignItems: "center", display: "inline-flex", fontSize: "90%" }}>
                    <Typography sx={{ pr: 1 }}>{item.label}</Typography>

                    <Box sx={{ lineHeight: 0, display: "inline-flex", alignItems: "center", fontSize: "80%" }}>
                        #{item.code}
                        <ScheduleSummary
                            id={item?._id ?? item?.id}
                            label={item?.label}
                            focused={focused}
                            placement="top"
                        />
                    </Box>
                </Box>
            }
            aria-label={`${item.label} ${item.code}, (Remove Schedule)`}
            onDelete={() => onRemove?.(item)}
            deleteIcon={
                <CloseIcon
                    sx={{
                        border: `2px solid ${focused ? theme.palette.primary.main : "transparent"}`,
                        borderRadius: "50%",
                        padding: "2px",
                        transition: "border-color 0.2s ease",
                    }}
                />
            }
        />
    )

    function handleFocus(event) {
        if (event.currentTarget.matches(":focus-visible")) {
            setFocused(true)
        }
    }

    function handleBlur() {
        setFocused(false)
    }

    function handleKeyDown(event) {
        if (event.key === "Enter" && onRemove) {
            event.stopPropagation()
            event.preventDefault()
            event.nativeEvent.stopImmediatePropagation()
            handleRemove()
        }
    }

    async function handleRemove() {
        const fallbackChip = chipRef.current?.previousElementSibling ?? chipRef.current?.nextElementSibling

        await onRemove?.(item)

        requestAnimationFrame(() => {
            fallbackChip?.focus?.()
        })
    }
}
